import { render, staticRenderFns } from "./content-loader.vue?vue&type=template&id=47b3a338&"
import script from "./content-loader.ts?vue&type=script&lang=ts&"
export * from "./content-loader.ts?vue&type=script&lang=ts&"
import style0 from "./content-loader.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports